import axios from 'axios';
export default {
  state: {
    consulta: null,
    consulta2: null,
    consulta3: null,
    busquedaAvanzada: null, // Nueva búsqueda avanzada
  },
  mutations: {
    setConsulta(state, consulta) {
      state.consulta = consulta;
    },
    setConsultaEnter(state, consulta) {
      console.log("Guardando en Vuex:", consulta);
      state.consulta2 = consulta;
    },
    setConsulta3(state, consulta) {
      state.consulta3 = consulta;
    },
    setBusquedaAvanzada(state, busqueda) {
      state.busquedaAvanzada = busqueda;
    },
    limpiarConsulta(state) {
      state.consulta = null;
    },
    limpiarConsultaEnter(state) {
      state.consulta2 = null;
    },
    limpiarConsulta3(state) {
      state.consulta3 = null;
    },
    limpiarBusquedaAvanzada(state) {
      state.busquedaAvanzada = null;
    },
  },
  actions: {
    guardarConsulta({ commit }, consulta) {
      commit('setConsulta', consulta);
    },
    guardarConsultaEnter({ commit }, consulta) {
      commit('setConsultaEnter', consulta);
    },
    guardarConsulta3({ commit }, consulta) {
      commit('setConsulta3', consulta);
    },
    guardarBusquedaAvanzada({ commit }, busqueda) {
      commit('setBusquedaAvanzada', busqueda);
    },
    resetConsulta({ commit }) {
      commit('limpiarConsulta');
    },
    resetConsultaEnter({ commit }) {
      commit('limpiarConsultaEnter');
    },
    resetConsulta3({ commit }) {
      commit('limpiarConsulta3');
    },
    resetBusquedaAvanzada({ commit }) {
      commit('limpiarBusquedaAvanzada');
    },
  },
  getters: {
    getConsulta: (state) => state.consulta,
    getConsulta2: (state) => state.consulta2,
    getConsulta3: (state) => state.consulta3,
    getBusquedaAvanzada: (state) => state.busquedaAvanzada,
  },
};
